// src/services/api/roleService.js
import axiosInstance from "./axiosInstance";

const ROLES_BASE_URL = "/roles";

const roleService = {
  getAllRoles: async () => {
    const response = await axiosInstance.get(ROLES_BASE_URL);
    return response.data;
  },

  /**
   * Get a specific role by ID with full permission details
   * @param {string} id - Role ID
   * @returns {Promise<Object>} Role details with permissions
   */
  getRoleById: async (id) => {
    const response = await axiosInstance.get(`${ROLES_BASE_URL}/${id}`);
    return response.data;
  },

  createRole: async (roleData) => {
    const response = await axiosInstance.post(ROLES_BASE_URL, roleData);
    return response.data;
  },

  updateRole: async (id, roleData) => {
    const response = await axiosInstance.put(
      `${ROLES_BASE_URL}/${id}`,
      roleData,
    );
    return response.data;
  },

  deleteRole: async (id) => {
    await axiosInstance.delete(`${ROLES_BASE_URL}/${id}`);
  },

  assignRoleToUser: async (userData) => {
    const response = await axiosInstance.post(
      `${ROLES_BASE_URL}/assign-user`,
      userData,
    );
    return response.data;
  },
};

export default roleService;
